export { FrequentlyBoughtTogether } from './FrequentlyBoughtTogether'
export type { FrequentlyBoughtTogetherProps } from './FrequentlyBoughtTogether'
